var Carousel = require('./fncs/Carousel.js');
var Navigation = require('./fncs/Navigation.js');
var Map = require('./fncs/Map.js');
var BtnEntry = require('./fncs/BtnEntry.js');

$(document).ready(function(){

  if($('.fnc-carousel').length === 1){
    Carousel.init();
  }

  if($('#fnc-map').length === 1){
    Map.init();
  }

  if($('.fnc-btnEntry').length === 1){
    BtnEntry.init();
  }

  Navigation.init();


});


// WEBPACK FOOTER //
// ./src/js/app.js